export const KEY_TUTORIAL_SQUALO = "tutorial_squalo";

export interface Bottiglia {

    id: string;
    punti: boolean;
}